module.exports = __webpack_public_path__ + "img/fail.55ac349c.png";